// Modules
import { useState } from "react";
import { sanitize } from "isomorphic-dompurify";

// Components
import LocationProduct from "components/searchPage/Products/LocationProduct";

// Types
import { ProductProps } from "interfaces/searchPage/products";

const InactiveProduct = ({ result, showHideLocations }: ProductProps) => {
	const [showNumberLocations, setShowNumberLocations] = useState(0);
	const [labelShowHideLocations, setLabelShowHideLocations] = useState("Mostra");

	return (
		<div className="wk-inactive-course">
			<div className="wk-course-info-section">
				<a className="wk-course-title" dangerouslySetInnerHTML={{ __html: sanitize(result.title) }} href={result.urlProduct} />
				<div className="wk-course-description"/>
				{result.productType !== "22" && (
					<>
						<div className="wk-course-location ">
							{result.locations &&
								result.locations
									.slice(0, showNumberLocations)
									.map((location, index) => (
										<LocationProduct
											key={result.documentId + index.toString()}
											location={location}
											startDate={result.startDateForLocations[index]}
											endDate={result.endDateForLocations[index]}
											productType={result.productType}
										/>
									))}
						</div>
						{result.locations.length > 0 && (
							<a
								className="wk-show-more"
								tabIndex={0}
								role="button"
								aria-label="Show/Hide locations"
								onClick={() => showHideLocations(result, showNumberLocations, setShowNumberLocations, setLabelShowHideLocations, 0)}
							>
								{labelShowHideLocations} altre sedi e date
							</a>
						)}
					</>
				)}
			</div>
			<div className="wk-subscriptions">Iscrizioni chiuse</div>
		</div>
	);
};

export default InactiveProduct;
